export default __webpack_public_path__ + "static/media/xmg.c705f6be.png";